import { registerHandler } from "../handler";

declare const rdt: any;

export default function registerHandlers() {
  registerHandler("lead", () => {
    rdt("track", "Lead");
  });

  registerHandler("purchase", () => {
    rdt("track", "SignUp");
  });
}
